module.exports = __webpack_public_path__ + "img/MPS_icon.8681265e.png";